import { render, staticRenderFns } from "./PoiIcon.vue?vue&type=template&id=9804aa70&"
import script from "./PoiIcon.vue?vue&type=script&lang=js&"
export * from "./PoiIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports